import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Drawer,
  Typography,
  LinearProgress,
  MenuItem,
  Container,
  AppBar,
  Toolbar,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider,
  InputLabel,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import { styled } from 'styled-components';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { authAtom } from '../../../../../states/usuarios/AuthState';
import { useHistoricoAcoesActions } from '../../../../../states/historicos/historicoAcoes.actions';
import { useTipoDeAcaoActions } from '../../../../../states/tiposDeAcoes/tipoDeAcao.actions';
import { IAcoes, IHistoricoAcoes, ITipoDeAcao } from '../../../../../commons/types/acoes';
import { IconDrawer } from '../../../../../commons/styleds/icons';
import { SelectStato } from '../../../../../commons/styleds/selects';
import { TextFieldStato } from '../../../../../commons/styleds/textFields';
import InputArquivo from '../../../../../components/InputArquivo/InputArquivo';
import { ButtonStato } from '../../../../../commons/styleds/buttons';
import { GridItemCadastro } from '../../MercadoAlvo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useTranslation } from '../../../../../commons/useTranslasion';
import { esES, ptBR } from '@mui/material/locale';
import { useDateFormatters } from '../../../../../utils/useDateFormatters';

const empty: IHistoricoAcoes = {  
  id: 0,
  idTipo: 0,
  idComanda: 0,
  idContato: 0,
  dtPrevista: undefined,
  dtCadastro: dayjs(),
  observacoes: '',
  anexo: undefined,
  realizada: false,
  habilitarEmpresas: false,
  habilitarAssessorado: false,
  notificarMesa: false,
  notificarPool: false,
  notificarCex: false,
  ativo: false,
};

interface IParams {
  contatoId?: number;
  comandaId?: number;
  loading: boolean;
}

enum ActionType {
  Create,
  Edit,
}

const HistoricoComponent: React.FC<IParams> = (props) => {
  const { translate, language } = useTranslation();
  const { formatoDataDayjs, localeDayjs, formatarData } = useDateFormatters();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }

  const { contatoId, comandaId } = props;
  const historicoAcoesActions = useHistoricoAcoesActions();
  const tipoDeAcaoActions = useTipoDeAcaoActions();
  const [open, setOpen] = useState<boolean>(false);
  const [loadingSave, setLoadingSave] = useState<boolean>(false);
  const [historicos, setHistoricos] = useState<IHistoricoAcoes[]>([]);
  const [historico, setHistorico] = useState<IHistoricoAcoes>(empty);
  const [tiposDeAcoes, setTiposDeAcoes] = useState<ITipoDeAcao[]>([]);
  const [editAcao, setEditAcao] = useState<boolean>(false);
  const [acaoEmEdicao, setAcaoEmEdicao] = useState<IHistoricoAcoes>(empty);
  const [nomeArquivo, setNomeArquivo] = useState('');
  const [arquivoUrl, setArquivoUrl] = useState('');
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');
  const [startDate, setStartDate] = useState<dayjs.Dayjs | null>(null);
  const [endDate, setEndDate] = useState<dayjs.Dayjs | null>(null);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    tipoDeAcaoActions
      .list()
      .then((resp: ITipoDeAcao[]) => setTiposDeAcoes(resp.filter((f) => f.ativo)))
      .catch((err) => toast.warn(err));

    historicoAcoesActions
      .list(false, `?contatoId=${contatoId}`)
      .then((data: IHistoricoAcoes[]) => setHistoricos(data.filter((f) => f.ativo)));

  }, []);

  const openDrawerHistorico = (result: any) => {
    setHistorico(empty);
    setOpen(result);

    if (!result) {
      setEditAcao(false);
      setNomeArquivo('');
      setArquivoUrl('');
    }
  };

  const HandleEditar = (acaoEmEdicao: any) => {
    acaoEmEdicao!.dtPrevista = dayjs(new Date(acaoEmEdicao.dtPrevista));
    setEditAcao(true);
    setAcaoEmEdicao(acaoEmEdicao);

    if (acaoEmEdicao.anexoURL) {
      setNomeArquivo(acaoEmEdicao.anexo);
      setArquivoUrl(acaoEmEdicao.anexoURL);
    }

    openDrawerHistorico(true);
  };

  const submitAcao = (actionType: ActionType) => {
    setLoadingSave(true);

    if (actionType === ActionType.Create) {
      const data: any = {
        idTipo: historico.idTipo,
        idContato: contatoId,
        idComanda: comandaId,
        dtPrevista: historico.dtCadastro,
        dtCadastro: historico.dtCadastro,
        observacoes: historico.observacoes,
        anexoFile: historico.anexo,
        realizada: historico.realizada,
        habilitarEmpresas: historico.habilitarEmpresas,
        habilitarAssessorado: historico.habilitarAssessorado,
        notificarMesa: historico.notificarMesa,
        notificarPool: historico.notificarPool,
        notificarCex: historico.notificarCex,
        ativo: true,
      };

      historicoAcoesActions
        .createFormData(data)
        .then((result: IHistoricoAcoes) => {
          setHistoricos(historicos.concat(result as IHistoricoAcoes));
          toast.success(translate('cadastroRealizadoComSucesso'));
        })
        .catch(() => {
          toast.error(translate('erroAoCadastrar'));
        });
    }

    if (actionType === ActionType.Edit) {
      const data: any = {
        idTipo: acaoEmEdicao.idTipo,
        idComanda: acaoEmEdicao.idComanda,
        idContato: acaoEmEdicao.idContato,
        dtPrevista: acaoEmEdicao.dtCadastro,
        dtCadastro: acaoEmEdicao.dtCadastro,
        observacoes: acaoEmEdicao.observacoes,
        anexoFile: acaoEmEdicao.anexo,
        realizada: acaoEmEdicao.realizada,
        habilitarEmpresas: acaoEmEdicao.habilitarEmpresas,
        habilitarAssessorado: acaoEmEdicao.habilitarAssessorado,
        notificarMesa: acaoEmEdicao.notificarMesa,
        notificarPool: acaoEmEdicao.notificarPool,
        notificarCex: acaoEmEdicao.notificarCex,
        ativo: acaoEmEdicao.ativo,
      };

      historicoAcoesActions
        .updateFormData(acaoEmEdicao.id!, data)
        .then((result: IHistoricoAcoes) => {
          const acao = historicos.filter((f) => f.id !== result.id);
          setHistoricos(acao.concat(result).sort((a, b) => a.id! - b.id!));
          toast.success(translate('atualizadoComSucesso'));
        })
        .catch(() => {
          toast.error(translate('erroAoAtualizar'));
        });
    }

    openDrawerHistorico(false);
    setLoadingSave(false);
  };

  const filteredAndSortedHistoricos = historicos
    ?.filter(item => {
      const matchesDate = (!startDate || dayjs(item.dtCadastro).isAfter(startDate)) &&
        (!endDate || dayjs(item.dtCadastro).isBefore(endDate.add(1, 'day')));
      const matchesText = !searchText || 
        item.observacoes?.toLowerCase().includes(searchText.toLowerCase());
      return matchesDate && matchesText;
    })
    .sort((a, b) => {
      const dateA = new Date(a.dtCadastro as any).getTime();
      const dateB = new Date(b.dtCadastro as any).getTime();
      return sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
    });

  return (
    <>
      <Grid item xs={12} md={12}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: "100%",
            borderRadius: 1,
          }}
        >
          <Grid sx={{
            width: '100%',
            paddingTop: '30px',
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
          }}>
            <AppBar
              position="sticky"
              color="default"
              elevation={1}
              sx={{ top: 65, zIndex: (theme) => theme.zIndex.appBar }}
            >
              <Toolbar sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                  <Typography 
                    variant="h6" 
                    component="div" 
                    sx={{ 
                      cursor: 'pointer', 
                      display: 'flex', 
                      alignItems: 'center',
                      '&:hover': { color: 'primary.main' }
                    }}
                    onClick={() => setSortDirection(prev => prev === 'asc' ? 'desc' : 'asc')}
                  >
                    {translate('historicoDeAcoes')}
                    {sortDirection === 'asc' ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={() => openDrawerHistorico(true)}
                  >
                    {translate('adicionarNovo')}
                  </Button>
                </Box>
                <Box sx={{ display: 'flex', gap: 2, width: '100%', alignItems: 'center' }}>
                  <Typography variant="body1">{translate('filtrar')}</Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={localeDayjs}>
                    <DatePicker
                      label={translate('dataInicial')}
                      value={startDate}
                      onChange={(newValue) => {
                        setStartDate(newValue);
                        if (endDate && newValue && endDate.isBefore(newValue)) {
                          setEndDate(null);
                        }
                      }}
                      format={formatoDataDayjs}
                      slotProps={{ 
                        textField: { 
                          size: 'small', 
                          sx: { minWidth: '150px' } 
                        } 
                      }}
                    />
                    <DatePicker
                      label={translate('dataFinal')}
                      value={endDate}
                      onChange={(newValue) => setEndDate(newValue)}
                      format={formatoDataDayjs}
                      minDate={startDate || undefined}
                      slotProps={{ 
                        textField: { 
                          size: 'small', 
                          sx: { minWidth: '150px' } 
                        } 
                      }}
                    />
                  </LocalizationProvider>
                  <TextFieldStato
                    size="small"
                    label={translate('filtrarPorObservacoes')}
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    sx={{ flexGrow: 1 }}
                  />
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => {
                      setStartDate(null);
                      setEndDate(null);
                      setSearchText('');
                    }}
                  >
                    {translate('limparFiltros')}
                  </Button>
                </Box>
              </Toolbar>
            </AppBar>
            <List sx={{
              flexGrow: 1,
              overflow: 'auto',
              bgcolor: '#fafafa',
              maxHeight: 'calc(100vh - 400px)',
              minHeight: '200px'
            }}>
              {filteredAndSortedHistoricos?.map((item, index) => (
                <div key={index}>
                  <ListItem alignItems="flex-start">
                    <ListItemText
                      primary={
                        <Typography
                          component="span"
                          color="primary"
                          sx={{ cursor: 'pointer' }}
                          onClick={() => HandleEditar(item)}
                        >
                          {tiposDeAcoes.find((t) => t.id === item.idTipo)?.nome}
                        </Typography>
                      }
                      secondary={
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <div>{item.observacoes}</div>
                          <div>{formatarData(item.dtCadastro)}</div>
                        </div>
                      }
                    />
                  </ListItem>
                  <Divider />
                </div>
              ))}
            </List>
          </Grid>

          <Drawer
            style={{ minWidth: '250px' }}
            anchor={'right'}
            open={open}
            onClose={() => openDrawerHistorico(false)}
          >
            <Grid
              item
              xs={12}
              md={12}
              style={{ padding: '90px 30px', maxWidth: '500px', width: 'auto' }}
            >
              <Grid item xs={12} md={12} style={{ display: 'flex', justifyContent: 'center' }}>
                <Grid item xs={2} md={2}>
                  <IconDrawer onClick={() => openDrawerHistorico(false)}>close</IconDrawer>
                </Grid>
                <Grid item xs={10} md={10}>
                  <Typography variant="h5" sx={{ paddingBottom: '20px' }}>
                    {editAcao ? 'Editar Ação' : 'Adicionar Ação'}
                  </Typography>
                </Grid>
              </Grid>

              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">{translate('tipoDeAcoes')}</InputLabel>
                <SelectStato
                  required
                  value={editAcao ? acaoEmEdicao.idTipo : undefined}
                  label={translate('tipoDeAcoes')}
                  onChange={(event: any) => {
                    editAcao
                      ? setAcaoEmEdicao({ ...acaoEmEdicao, idTipo: event.target.value })
                      : setHistorico({ ...historico, idTipo: event.target.value });
                  }}
                >
                  {tiposDeAcoes?.map((acao: IAcoes, index: number) => {
                    return (
                      <MenuItem value={acao.id} key={index}>
                        {acao.nome}
                      </MenuItem>
                    );
                  })}
                </SelectStato>
              </FormControl>

              {editAcao ? (
                <Typography sx={{ marginTop: '20px' }}>
                  {translate('dataDaAcao')}: {formatarData(acaoEmEdicao.dtCadastro)}
                </Typography>
              ) : (
                <FormControl fullWidth sx={{ marginTop: '20px' }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={localeDayjs}>
                    <DatePicker
                      label={translate('dataDaAcao')}
                      value={dayjs(historico.dtCadastro)}
                      onChange={(newValue) => setHistorico({ ...historico, dtCadastro: newValue! })}
                      maxDate={dayjs()}
                      format={formatoDataDayjs}
                      slotProps={{ 
                        textField: { 
                          required: true,
                          size: 'small'
                        } 
                      }}
                    />
                  </LocalizationProvider>
                </FormControl>
              )}

              <FormControlLabel
                required
                sx={{ marginTop: '20px' }}
                label={translate('realizada')}
                control={
                  <Checkbox
                    checked={editAcao ? acaoEmEdicao.realizada : historico.realizada}
                    onClick={() => {
                      editAcao
                        ? setAcaoEmEdicao({ ...acaoEmEdicao, realizada: !acaoEmEdicao.realizada })
                        : setHistorico({ ...historico, realizada: !historico.realizada });
                    }}
                  />
                }
              />

              <FormControlLabel
                required
                sx={{ marginTop: '20px' }}
                label={translate('notificarMesa')}
                control={
                  <Checkbox
                    checked={editAcao ? acaoEmEdicao.notificarMesa : historico.notificarMesa}
                    onClick={() => {
                      editAcao
                        ? setAcaoEmEdicao({
                          ...acaoEmEdicao,
                          notificarMesa: !acaoEmEdicao.notificarMesa,
                        })
                        : setHistorico({ ...historico, notificarMesa: !historico.notificarMesa });
                    }}
                  />
                }
              />

              <FormControlLabel
                required
                sx={{ marginTop: '20px' }}
                label={translate('notificarPool')}
                control={
                  <Checkbox
                    checked={editAcao ? acaoEmEdicao.notificarPool : historico.notificarPool}
                    onClick={() => {
                      editAcao
                        ? setAcaoEmEdicao({
                          ...acaoEmEdicao,
                          notificarPool: !acaoEmEdicao.notificarPool,
                        })
                        : setHistorico({ ...historico, notificarPool: !historico.notificarPool });
                    }}
                  />
                }
              />

              <FormControlLabel
                required
                sx={{ marginTop: '20px' }}
                label={translate('habilitarEmpresas')}
                control={
                  <Checkbox
                    checked={
                      editAcao ? acaoEmEdicao.habilitarEmpresas : historico.habilitarEmpresas
                    }
                    onClick={() => {
                      editAcao
                        ? setAcaoEmEdicao({
                          ...acaoEmEdicao,
                          habilitarEmpresas: !acaoEmEdicao.habilitarEmpresas,
                        })
                        : setHistorico({
                          ...historico,
                          habilitarEmpresas: !historico.habilitarEmpresas,
                        });
                    }}
                  />
                }
              />

              <FormControlLabel
                required
                sx={{ marginTop: '20px' }}
                label={translate('habilitarAssessorado')}
                control={
                  <Checkbox
                    checked={
                      editAcao ? acaoEmEdicao.habilitarAssessorado : historico.habilitarAssessorado
                    }
                    onClick={() => {
                      editAcao
                        ? setAcaoEmEdicao({
                          ...acaoEmEdicao,
                          habilitarAssessorado: !acaoEmEdicao.habilitarAssessorado,
                        })
                        : setHistorico({
                          ...historico,
                          habilitarAssessorado: !historico.habilitarAssessorado,
                        });
                    }}
                  />
                }
              />

              <FormControlLabel
                required
                sx={{ marginTop: '20px' }}
                label={translate('notificarCex')}
                control={
                  <Checkbox
                    checked={editAcao ? acaoEmEdicao.notificarCex : historico.notificarCex}
                    onClick={() => {
                      editAcao
                        ? setAcaoEmEdicao({
                          ...acaoEmEdicao,
                          notificarCex: !acaoEmEdicao.notificarCex,
                        })
                        : setHistorico({ ...historico, notificarCex: !historico.notificarCex });
                    }}
                  />
                }
              />

              <FormControl required fullWidth variant="outlined" sx={{ marginTop: '20px' }}>
                <TextFieldStato
                  id={'obsInput'}
                  type="text"
                  label={translate('observacao')}
                  multiline
                  maxRows={4}
                  value={editAcao ? acaoEmEdicao.observacoes : historico?.observacoes}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    editAcao
                      ? setAcaoEmEdicao({ ...acaoEmEdicao, observacoes: event.target.value })
                      : setHistorico({ ...historico, observacoes: event.target.value });
                  }}
                />
              </FormControl>

              <InputArquivo
                isEdit={editAcao}
                objOnEdit={acaoEmEdicao}
                setObjOnEdit={setAcaoEmEdicao}
                newObj={historico}
                setNewObj={setHistorico}
                nameFile={nomeArquivo}
                setNameFile={setNomeArquivo}
                urlFile={arquivoUrl}
                setUrlFile={setArquivoUrl}
              />

              {loadingSave && <LinearProgress />}

              <GridItemCadastroBtnSalvar
                item
                xs={11}
                md={11}
                sx={{
                  position: 'fixed',
                  right: '0px',
                  bottom: '0px',
                }}
              >
                <ButtonStato
                  variant="contained"
                  onClick={() => submitAcao(editAcao ? ActionType.Edit : ActionType.Create)}
                >
                  {editAcao ? translate('editar') : translate('adicionar')}
                </ButtonStato>
              </GridItemCadastroBtnSalvar>
            </Grid>
          </Drawer>
        </Box>
      </Grid>
    </>
  );
};

export const GridItemCadastroBtnSalvar = styled(GridItemCadastro)`
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
  position: fixed;
  bottom: 5%;
  right: 4%;
  z-index: 50;
`;

export default HistoricoComponent;
